import React from 'react';

import { parseCopy } from '../../../../utils/parseCopy';
import * as styles from './SectionCopy.styles';

interface SectionCopyProps {
  copy: string;
}

export const SectionCopy = ({ copy }: SectionCopyProps) => {
  const parsedCopy = parseCopy(copy);

  return parsedCopy ? <div css={styles.sectionCopy}>{parsedCopy}</div> : null;
};
